/* Earth Energy homepage section — scroll reveal + optional in-section mobile drawer.
   All hooks are null-safe so the section is safe inside any theme (the theme owns the real header). */
(function(){
  var root=document.querySelector('.ee-home');
  if(!root) return;

  // Optional in-section drawer (only if this section renders its own menu button)
  var drawer=root.querySelector('#ee-home-drawer');
  var menuBtn=root.querySelector('#ee-home-menu');
  var closeBtn=root.querySelector('#ee-home-drawer-close');
  if(drawer&&menuBtn){
    menuBtn.addEventListener('click',function(){drawer.classList.add('open');});
    if(closeBtn) closeBtn.addEventListener('click',function(){drawer.classList.remove('open');});
    drawer.addEventListener('click',function(e){if(e.target===drawer)drawer.classList.remove('open');});
    drawer.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){drawer.classList.remove('open');});});
  }

  // Scroll reveal
  var els=root.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});
    },{threshold:.12});
    els.forEach(function(el){io.observe(el);});
  }else{
    els.forEach(function(el){el.classList.add('in');});
  }
})();
